import { render, staticRenderFns } from "./commentBox.vue?vue&type=template&id=7e69295a&scoped=true"
import script from "./commentBox.vue?vue&type=script&lang=js"
export * from "./commentBox.vue?vue&type=script&lang=js"
import style0 from "./commentBox.vue?vue&type=style&index=0&id=7e69295a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e69295a",
  null
  
)

export default component.exports